module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-select', {
    attrs: {
      "label": _vm.label,
      "options": _vm.activeOptions,
      "select-type": "custom",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.valueAlign
    },
    on: {
      "selector-click": _vm.handleSelectorClick
    },
    scopedSlots: _vm._u([{
      key: "display",
      fn: function(scope) {
        return [_c('span', {
          class: [{
            'mt-color-grey-lv3': (scope.value === '') || (Object.prototype.toString.call(scope.value) === '[object Array]' && scope.value.length === 0)
          }]
        }, [_vm._v(_vm._s(scope.value === '' || (Object.prototype.toString.call(scope.value) === '[object Array]' && scope.value.length === 0) ? _vm.placeholder : _vm.getDisplay(scope.value)))])]
      }
    }, {
      key: "selector",
      fn: function(scope) {
        return [_c('bread', {
          attrs: {
            "data": _vm.breadData,
            "active-id": (_vm.activePids.length ? _vm.activePids[_vm.activePids.length - 1] : '')
          },
          on: {
            "item-click": _vm.handleBreadClick
          }
        }), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.options.length === 0),
            expression: "scope.options.length === 0"
          }],
          staticClass: "mint-tree-selector-loading"
        }, [_vm._v("暂无数据")]), (!_vm.multiple) ? [_c('mt-cell-group', {
          style: ([{
            height: _vm.parentSelectable ? 'calc(100% - 88px)' : null,
            overflow: 'auto'
          }])
        }, _vm._l((scope.options), function(item) {
          return _c('mt-cell', {
            key: item.id,
            class: {
              active: scope.value.indexOf(item) > -1
            },
            attrs: {
              "title": item.name,
              "is-link": !!item.isParent
            },
            nativeOn: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.handleItemClick(item, $event)
              }
            }
          })
        })), (_vm.parentSelectable) ? _c('mt-button', {
          attrs: {
            "size": "large",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              _vm.handleConfirmClick('single')
            }
          }
        }, [_vm._v("确定")]) : _vm._e()] : (_vm.multiple) ? [_c('tree-checkbox-list', {
          staticClass: "mint-tree-selector-multi-list",
          attrs: {
            "options": scope.options,
            "parentSelectable": _vm.parentSelectable,
            "iconpattern": _vm.iconpattern
          },
          on: {
            "item-click": _vm.handleItemClick
          },
          model: {
            value: (_vm.currentValue),
            callback: function($$v) {
              _vm.currentValue = $$v
            },
            expression: "currentValue"
          }
        })] : _vm._e(), (_vm.multiple) ? _c('selected-footer', {
          attrs: {
            "options": _vm.footerOptions,
            "iconpattern": _vm.iconpattern
          },
          on: {
            "confirm-click": _vm.handleConfirmClick
          },
          model: {
            value: (_vm.currentValue),
            callback: function($$v) {
              _vm.currentValue = $$v
            },
            expression: "currentValue"
          }
        }) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7b161ba","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/tree-selector/src/tree-selector.vue
// module id = 433
// module chunks = 0